<template>
  <!-- Site Assessment -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 3.5 32 25"
    fill="currentColor"
    :class="!isTopBar ? 'w-8 h-8' : 'w-5 h-5'"
    v-if="name.includes('site-assessment')"
  >
    <g>
      <path
        d="M27,4H5C3.3,4,2,5.3,2,7v14c0,1.7,1.3,3,3,3h5v2H7c-0.6,0-1,0.4-1,1s0.4,1,1,1h18c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3v-2h5
             c1.7,0,3-1.3,3-3V7C30,5.3,28.7,4,27,4z M20,26h-8v-2h8V26z M28,21c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1v-1h24V21z M28,18H4V7
             c0-0.6,0.4-1,1-1h22c0.6,0,1,0.4,1,1V18z"
      />
      <path
        d="M19,11h-2V9c0-0.6-0.4-1-1-1s-1,0.4-1,1v2h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2h2
             c0.6,0,1-0.4,1-1S19.6,11,19,11z"
      />
    </g>
  </svg>

  <!-- PS Customer Server -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13.758333 9.5249996"
    fill="currentColor"
    :class="!isTopBar ? 'w-8 h-8' : 'w-5 h-5'"
    v-if="name.includes('ps-customer-server') || name.includes('ps-estimate')"
  >
    <g transform="translate(-23.358929,-132.73155)">
      <path
        d="M 36.588096,132.73155 H 23.888095 c -0.2921,0 -0.529166,0.23706 -0.529166,0.52916 v 4.23334 c 0,0.2921 0.237066,0.52916 0.529166,0.52916 h 5.820834 v 1.15094 c -0.449792,0.15981 -0.805921,0.51594 -0.965729,0.96573 h -2.738438 c -0.2921,0 -0.529167,0.23707 -0.529167,0.52917 0,0.2921 0.237067,0.52916 0.529167,0.52916 H 28.7432 c 0.218545,0.61543 0.805127,1.05834 1.494895,1.05834 0.689769,0 1.276086,-0.44291 1.494896,-1.05834 h 2.738438 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 0,-0.2921 -0.237067,-0.52917 -0.529167,-0.52917 h -2.738438 c -0.159808,-0.44979 -0.515937,-0.80592 -0.965729,-0.96573 v -1.15094 h 5.820834 c 0.2921,0 0.529166,-0.23706 0.529166,-0.52916 v -4.23334 c 0,-0.2921 -0.237066,-0.52916 -0.529166,-0.52916 z m -6.350001,8.46666 c -0.291835,0 -0.529166,-0.23733 -0.529166,-0.52916 0,-0.29184 0.237331,-0.52917 0.529166,-0.52917 0.291836,0 0.529167,0.23733 0.529167,0.52917 0,0.29183 -0.237331,0.52916 -0.529167,0.52916 z m 5.820834,-4.23333 H 24.417262 v -3.175 h 11.641667 z"
      />
      <circle r="0.52916664" cy="135.37738" cx="33.942261" />
      <path
        d="m 26.004762,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
      <path
        d="m 27.592262,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
      <path
        d="m 29.179762,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
      <path
        d="m 30.767262,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
    </g>
  </svg>

  <!-- License Tracker -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13.758333 9.5249996"
    fill="currentColor"
    :class="!isTopBar ? 'w-8 h-8' : 'w-5 h-5'"
    v-if="name.includes('license-tracker')"
  >
    <g transform="translate(-23.358929,-132.73155)">
      <path
        d="M 36.588096,132.73155 H 23.888095 c -0.2921,0 -0.529166,0.23706 -0.529166,0.52916 v 4.23334 c 0,0.2921 0.237066,0.52916 0.529166,0.52916 h 5.820834 v 1.15094 c -0.449792,0.15981 -0.805921,0.51594 -0.965729,0.96573 h -2.738438 c -0.2921,0 -0.529167,0.23707 -0.529167,0.52917 0,0.2921 0.237067,0.52916 0.529167,0.52916 H 28.7432 c 0.218545,0.61543 0.805127,1.05834 1.494895,1.05834 0.689769,0 1.276086,-0.44291 1.494896,-1.05834 h 2.738438 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 0,-0.2921 -0.237067,-0.52917 -0.529167,-0.52917 h -2.738438 c -0.159808,-0.44979 -0.515937,-0.80592 -0.965729,-0.96573 v -1.15094 h 5.820834 c 0.2921,0 0.529166,-0.23706 0.529166,-0.52916 v -4.23334 c 0,-0.2921 -0.237066,-0.52916 -0.529166,-0.52916 z m -6.350001,8.46666 c -0.291835,0 -0.529166,-0.23733 -0.529166,-0.52916 0,-0.29184 0.237331,-0.52917 0.529166,-0.52917 0.291836,0 0.529167,0.23733 0.529167,0.52917 0,0.29183 -0.237331,0.52916 -0.529167,0.52916 z m 5.820834,-4.23333 H 24.417262 v -3.175 h 11.641667 z"
      />
      <circle r="0.52916664" cy="135.37738" cx="33.942261" />
      <path
        d="m 26.004762,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
      <path
        d="m 27.592262,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
      <path
        d="m 29.179762,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
      <path
        d="m 30.767262,136.43571 c 0.2921,0 0.529167,-0.23706 0.529167,-0.52916 v -1.05834 c 0,-0.2921 -0.237067,-0.52916 -0.529167,-0.52916 -0.2921,0 -0.529167,0.23706 -0.529167,0.52916 v 1.05834 c 0,0.2921 0.237067,0.52916 0.529167,0.52916 z"
      />
    </g>
  </svg>
  <!-- DDI Library -->
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-5 h-5"
    v-if="name.includes('ddi-library')"
  >
    <path
      d="M18.43 17.58H5.57001C4.50914 17.58 3.49173 17.1586 2.74158 16.4084C1.99143 15.6583 1.57001 14.6409 1.57001 13.58V6.57999C1.57001 5.51912 1.99143 4.5017 2.74158 3.75156C3.49173 3.00141 4.50914 2.57999 5.57001 2.57999H18.43C19.4909 2.57999 20.5083 3.00141 21.2584 3.75156C22.0086 4.5017 22.43 5.51912 22.43 6.57999V13.63C22.4169 14.6822 21.9896 15.6868 21.2409 16.4261C20.4922 17.1655 19.4823 17.5801 18.43 17.58ZM5.57001 4.04999C4.91043 4.05262 4.27862 4.3158 3.81222 4.7822C3.34582 5.2486 3.08264 5.88041 3.08001 6.53999V13.59C3.08001 14.2504 3.34235 14.8837 3.80931 15.3507C4.27628 15.8176 4.90962 16.08 5.57001 16.08H18.43C18.757 16.08 19.0808 16.0156 19.3829 15.8904C19.685 15.7653 19.9595 15.5819 20.1907 15.3507C20.4219 15.1195 20.6053 14.845 20.7305 14.5429C20.8556 14.2408 20.92 13.917 20.92 13.59V6.58999C20.9174 5.93041 20.6542 5.2986 20.1878 4.8322C19.7214 4.3658 19.0896 4.10262 18.43 4.09999L5.57001 4.04999Z"
      fill="currentColor"
    />
    <path
      d="M21.67 13.78H2.33C2.13109 13.78 1.94032 13.701 1.79967 13.5603C1.65902 13.4197 1.58 13.2289 1.58 13.03C1.58 12.8311 1.65902 12.6403 1.79967 12.4997C1.94032 12.359 2.13109 12.28 2.33 12.28H21.67C21.8689 12.28 22.0597 12.359 22.2003 12.4997C22.341 12.6403 22.42 12.8311 22.42 13.03C22.42 13.2289 22.341 13.4197 22.2003 13.5603C22.0597 13.701 21.8689 13.78 21.67 13.78Z"
      fill="currentColor"
    />
    <path
      d="M12 21.45C11.8011 21.45 11.6103 21.371 11.4697 21.2303C11.329 21.0897 11.25 20.8989 11.25 20.7V16.83C11.25 16.6311 11.329 16.4403 11.4697 16.2997C11.6103 16.159 11.8011 16.08 12 16.08C12.1989 16.08 12.3897 16.159 12.5303 16.2997C12.671 16.4403 12.75 16.6311 12.75 16.83V20.7C12.75 20.8989 12.671 21.0897 12.5303 21.2303C12.3897 21.371 12.1989 21.45 12 21.45Z"
      fill="currentColor"
    />
    <path
      d="M17.8 21.45H6.20001C6.0011 21.45 5.81033 21.371 5.66968 21.2303C5.52903 21.0897 5.45001 20.8989 5.45001 20.7C5.45001 20.5011 5.52903 20.3103 5.66968 20.1697C5.81033 20.029 6.0011 19.95 6.20001 19.95H17.8C17.9989 19.95 18.1897 20.029 18.3303 20.1697C18.471 20.3103 18.55 20.5011 18.55 20.7C18.55 20.8989 18.471 21.0897 18.3303 21.2303C18.1897 21.371 17.9989 21.45 17.8 21.45Z"
      fill="currentColor"
    />
  </svg>

  <!-- Master Variable -->
  <svg
    viewBox="0 0 306.028 306.028"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    class="w-5 h-5"
    v-if="name.includes('master-variable')"
  >
    <g>
      <path
        d="M285.498,113.47H81.32V15h179.688v76.277c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5V7.5
            c0-4.142-3.357-7.5-7.5-7.5H73.82c-4.143,0-7.5,3.358-7.5,7.5v113.47c0,0.438,0.045,0.864,0.117,1.281v149.841
            c0,10.441-8.494,18.936-18.936,18.936h-0.534c-10.441,0-18.937-8.495-18.937-18.936V91.963h18.937c4.143,0,7.5-3.358,7.5-7.5
            s-3.357-7.5-7.5-7.5H20.531c-4.143,0-7.5,3.358-7.5,7.5v187.629c0,18.712,15.224,33.936,33.937,33.936h0.534h201.197
            c24.427,0,44.299-19.873,44.299-44.299V120.97C292.998,116.828,289.64,113.47,285.498,113.47z M277.998,261.729
            c0,16.155-13.144,29.299-29.299,29.299H75.649c3.653-5.412,5.788-11.929,5.788-18.936V128.47h196.561V261.729z"
      />
      <path
        d="M98.011,41.633h49.663c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H98.011c-4.143,0-7.5,3.358-7.5,7.5
            S93.869,41.633,98.011,41.633z"
      />
      <path
        d="M192.257,55.205H98.011c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h94.246c4.143,0,7.5-3.358,7.5-7.5
            S196.4,55.205,192.257,55.205z"
      />
      <path
        d="M192.257,83.777H98.011c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h94.246c4.143,0,7.5-3.358,7.5-7.5
            S196.4,83.777,192.257,83.777z"
      />
      <path
        d="M220.174,55.205c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h20.417c4.143,0,7.5-3.358,7.5-7.5
            s-3.357-7.5-7.5-7.5H220.174z"
      />
    </g>
  </svg>

  <!-- Data Sync -->
  <svg
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    class="w-5 h-5"
    v-if="name.includes('data-sync')"
  >
    <path
      d="M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z"
    />
    <path
      d="M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z"
    />
  </svg>

  <!-- Gateway Management -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    class="w-5 h-5"
    v-if="name.includes('gateway-management')"
  >
    <path
      d="M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
    />
    <path
      d="M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
    />
  </svg>

  <!-- Unit -->
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    class="w-5 h-5"
    v-if="name.includes('unit')"
  >
    <path
      d="M2.602,0.968C1.349,0.968,0,1.916,0,4v56c0,2.206,1.794,4,4,4h56c1.95,0,2.639-1.154,2.845-1.65
      c0.205-0.496,0.534-1.799-0.845-3.178L4.828,2C3.975,1.146,3.146,0.968,2.602,0.968z M4,60v-4h4c1.104,0,2-0.896,2-2s-0.896-2-2-2
      H4v-4h2c1.104,0,2-0.896,2-2s-0.896-2-2-2H4v-4h4c1.104,0,2-0.896,2-2s-0.896-2-2-2H4v-4h2c1.104,0,2-0.896,2-2s-0.896-2-2-2H4v-4
      h4c1.104,0,2-0.896,2-2s-0.896-2-2-2H4V7l53.169,53H4z"
    />
    <path
      d="M16,56h24c1.95,0,2.639-1.154,2.845-1.65c0.205-0.496,0.534-1.799-0.845-3.178L16.828,26
      c-0.854-0.854-1.682-1.032-2.227-1.032C13.349,24.968,12,25.916,12,28v24C12,54.206,13.794,56,16,56z M16.001,30.83L37.17,52H16
      L16.001,30.83z"
    />
    <path
      d="M55.456,46.426l4.119,1.029c0.316,0.079,0.632,0.119,0.938,0.119c0,0,0,0,0.001,0c0.975,0,1.857-0.414,2.422-1.137
      c0.604-0.772,0.788-1.789,0.52-2.862l-1.029-4.119c-0.353-1.412-1.396-3.254-2.426-4.284L26.828,2
      C26.074,1.246,25.07,0.831,24,0.831S21.926,1.246,21.172,2L18,5.172c-1.56,1.56-1.56,4.097,0,5.656L51.172,44
      C52.202,45.03,54.044,46.073,55.456,46.426z M58.545,40.425l0.706,2.826l-2.826-0.706c-0.721-0.18-1.898-0.848-2.425-1.373
      L26.828,14L30,10.828L57.172,38C57.697,38.526,58.365,39.704,58.545,40.425z M24,4.828L27.172,8L24,11.172L20.828,8L24,4.828z"
    />
  </svg>

  <!-- Patient Tile Composer -->
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1325.000000 837.000000" preserveAspectRatio="xMidYMid meet" class="w-8 h-8" stroke="currentColor" stroke-width="1.5" v-if="name.includes('patient-tile-composer')">
    <g transform="translate(0.000000,837.000000) scale(0.100000,-0.100000)"
    fill="#000000" stroke="none">
    <path d="M2607 8224 c-1 -1 -38 -4 -81 -8 -44 -4 -83 -9 -88 -12 -4 -3 -18 -7
    -30 -10 -39 -9 -53 -12 -53 -14 0 -1 -8 -3 -18 -5 -31 -6 -164 -72 -214 -107
    -97 -66 -188 -159 -260 -266 -28 -42 -50 -78 -48 -81 3 -2 -7 -23 -21 -47 -14
    -24 -23 -44 -19 -44 4 0 2 -7 -5 -15 -7 -8 -9 -15 -5 -15 4 0 3 -6 -2 -12 -14
    -17 -27 -72 -41 -163 -4 -27 -7 -1256 -7 -2730 0 -2538 1 -2684 18 -2763 19
    -87 29 -117 80 -221 123 -256 375 -447 657 -500 36 -7 576 -10 1570 -10 833
    -1 1521 -1 1528 -1 11 0 13 -12 9 -47 -10 -92 -49 -247 -73 -295 -8 -14 -14
    -33 -14 -42 0 -8 -23 -55 -52 -103 -78 -132 -180 -218 -289 -242 -24 -6 -108
    -11 -185 -12 -112 -1 -149 -5 -180 -19 -44 -20 -94 -68 -99 -96 -2 -11 -4 -19
    -5 -19 -1 0 -4 -14 -6 -32 -10 -67 33 -150 93 -182 16 -8 521 -11 1938 -12
    1904 0 1916 0 1948 20 38 23 77 88 84 138 6 44 -19 112 -55 146 -48 46 -86 55
    -232 56 -161 2 -189 6 -255 38 -45 23 -175 137 -175 155 0 4 -13 26 -29 50
    -16 24 -41 72 -55 108 -15 36 -30 72 -35 80 -5 9 -12 36 -16 60 -4 25 -11 50
    -15 55 -8 11 -31 125 -34 165 l-1 25 1550 5 c1537 5 1551 5 1620 26 269 81
    465 240 591 481 39 75 81 208 92 293 4 30 7 1263 7 2740 l0 2685 -22 80 c-31
    116 -58 182 -105 260 -23 38 -45 74 -50 80 -5 5 -18 21 -29 35 -51 62 -77 88
    -176 170 -7 5 -17 10 -23 10 -5 0 -10 4 -10 9 0 5 -10 13 -22 17 -13 4 -25 10
    -28 14 -21 30 -210 97 -330 116 -35 6 -8286 13 -8293 8z m8300 -388 c49 -13
    153 -59 182 -81 7 -5 39 -35 70 -65 64 -61 102 -121 140 -219 l26 -66 3 -978
    3 -977 -1133 2 -1132 3 -78 314 c-85 338 -95 363 -165 396 -120 57 -241 -6
    -269 -140 -2 -11 -6 -31 -9 -45 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50
    -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7
    -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10
    -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3
    -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7
    -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -8 -38 -11 -55 -3 -16 -6 -30 -7
    -32 -1 -1 -83 348 -181 775 -98 427 -187 796 -198 820 -28 60 -77 94 -143 100
    -29 2 -68 -1 -88 -7 -51 -17 -100 -75 -113 -136 -1 -5 -5 -23 -8 -40 -3 -16
    -8 -41 -11 -55 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36
    -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50
    -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7
    -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10
    -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3
    -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7
    -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10
    -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3
    -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7
    -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -7 -36 -10 -50 -3 -14 -8 -41 -11
    -60 -7 -44 -12 -48 -18 -19 -3 13 -89 499 -191 1079 -103 580 -191 1069 -196
    1087 -11 33 -60 91 -94 109 -36 19 -120 17 -162 -4 -40 -21 -85 -66 -76 -76 4
    -3 1 -6 -5 -6 -7 0 -11 -3 -11 -7 1 -5 0 -10 -1 -13 -4 -10 -14 -62 -25 -130
    -7 -43 -14 -81 -20 -110 -2 -13 -7 -40 -10 -60 -3 -20 -8 -47 -10 -60 -6 -29
    -13 -67 -20 -110 -7 -43 -14 -81 -20 -110 -2 -13 -7 -40 -10 -60 -3 -20 -8
    -47 -10 -60 -6 -28 -14 -71 -21 -115 -7 -43 -13 -76 -19 -105 -2 -13 -7 -40
    -10 -60 -3 -20 -8 -47 -10 -60 -6 -28 -14 -72 -20 -112 -7 -41 -14 -80 -20
    -108 -2 -13 -7 -40 -10 -60 -3 -20 -8 -47 -10 -60 -6 -28 -13 -67 -20 -107 -6
    -41 -14 -85 -20 -113 -2 -13 -7 -40 -10 -60 -3 -20 -8 -47 -10 -60 -6 -29 -12
    -62 -20 -107 -7 -47 -14 -84 -20 -113 -2 -13 -7 -40 -10 -60 -3 -20 -8 -47
    -10 -60 -10 -46 -18 -95 -18 -107 0 -7 -3 -13 -6 -13 -3 0 -87 403 -185 896
    -110 550 -187 911 -199 935 -29 58 -77 92 -142 97 -124 10 -187 -53 -219 -218
    -8 -40 -15 -70 -20 -88 -3 -9 -7 -28 -10 -42 -8 -41 -15 -70 -20 -88 -3 -9 -7
    -28 -10 -42 -8 -41 -15 -70 -20 -88 -3 -9 -7 -28 -10 -42 -8 -41 -15 -70 -20
    -88 -3 -9 -7 -28 -10 -42 -8 -41 -15 -70 -20 -88 -3 -9 -7 -28 -10 -42 -8 -41
    -15 -70 -20 -88 -3 -9 -7 -28 -10 -42 -8 -41 -15 -70 -20 -88 -3 -9 -7 -28
    -10 -42 -8 -41 -15 -70 -20 -88 -3 -9 -7 -28 -10 -42 -8 -41 -15 -70 -20 -88
    -3 -9 -7 -28 -10 -42 -8 -41 -15 -70 -20 -88 -3 -9 -7 -28 -10 -42 -8 -41 -15
    -71 -20 -88 -3 -9 -8 -33 -11 -52 -3 -19 -10 -48 -15 -65 -5 -16 -12 -43 -15
    -60 -6 -28 -12 -54 -15 -65 -2 -7 -50 128 -57 160 -18 81 -307 1029 -320 1050
    -75 117 -241 117 -314 0 -13 -21 -26 -61 -45 -142 -2 -10 -6 -27 -9 -38 -3
    -11 -7 -29 -10 -40 -3 -11 -7 -29 -10 -40 -3 -11 -7 -29 -10 -40 -3 -11 -7
    -29 -10 -40 -3 -11 -7 -29 -10 -40 -3 -11 -7 -29 -10 -40 -3 -11 -7 -29 -10
    -40 -3 -11 -7 -29 -10 -40 -3 -11 -7 -29 -10 -40 -21 -83 -23 -94 -24 -102 -1
    -5 -469 -8 -1041 -8 l-1040 0 0 948 c1 555 5 966 11 992 17 83 20 94 27 104 4
    6 7 13 8 16 8 41 68 127 134 191 59 58 151 110 236 134 74 20 8334 21 8411 1z
    m-4012 -3046 c109 -618 193 -1069 203 -1089 9 -19 34 -48 55 -65 34 -27 46
    -31 102 -31 54 0 69 4 106 30 44 31 74 78 83 130 3 17 8 41 11 55 3 14 7 36
    10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14
    7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50
    3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36
    10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14
    7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50
    3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36
    10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14
    7 36 10 50 3 14 8 39 11 55 3 17 7 37 9 45 2 8 4 24 5 35 l1 20 9 -20 c5 -11
    88 -364 185 -785 96 -421 184 -783 195 -805 31 -61 82 -90 157 -90 52 0 68 5
    104 30 44 31 74 78 83 130 3 17 8 41 11 55 3 14 7 36 10 50 3 14 7 36 10 50 3
    14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10
    50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7
    36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3 14 7 36 10 50 3
    14 7 36 10 50 8 40 17 84 20 100 2 8 4 19 4 24 1 5 15 -5 32 -23 25 -27 58
    -47 92 -56 4 -2 556 -3 1227 -4 l1220 -1 0 -1014 c0 -802 -3 -1015 -12 -1018
    -11 -4 -8936 -3 -9160 1 l-78 1 0 1015 0 1015 1128 0 1128 0 52 26 c28 14 54
    34 57 45 4 10 11 19 16 19 5 0 8 3 7 8 0 4 2 14 5 22 3 8 11 35 18 60 l11 45
    186 -619 c177 -588 187 -620 221 -655 46 -46 66 -56 118 -60 55 -3 123 27 155
    70 31 41 37 58 63 174 2 11 6 30 9 43 6 22 12 49 21 87 2 11 6 30 9 43 6 22
    12 49 21 87 2 11 6 30 9 43 6 22 12 49 21 87 2 11 6 30 9 43 6 22 12 49 21 87
    2 11 6 30 9 43 11 41 23 99 31 140 3 15 8 35 11 44 3 10 7 30 10 45 3 16 10
    46 16 68 5 22 12 51 14 63 4 22 62 266 68 287 1 6 6 33 11 60 4 28 12 61 17
    75 6 14 12 39 15 55 3 17 8 36 12 42 7 13 45 -155 81 -357 11 -58 27 -139 36
    -180 9 -41 18 -86 21 -100 39 -209 257 -1289 263 -1306 22 -57 108 -114 172
    -114 48 1 111 33 141 71 32 44 37 59 62 209 8 49 14 81 20 110 2 13 7 40 10
    60 3 20 8 47 10 60 6 29 12 61 20 110 8 49 14 81 20 110 2 13 7 40 10 60 3 20
    8 47 10 60 6 28 14 72 20 113 7 40 14 79 20 107 2 13 7 40 10 60 3 20 8 47 10
    60 6 29 12 62 20 108 7 46 14 83 20 112 2 13 7 40 10 60 3 20 8 47 10 60 6 28
    13 67 20 108 6 40 14 84 20 112 2 13 7 40 10 60 3 20 8 47 10 60 6 28 13 67
    20 108 6 40 14 84 20 112 2 13 7 42 11 65 3 22 8 47 9 55 2 8 4 21 4 29 1 8 3
    12 5 10 3 -3 89 -479 191 -1059z m4433 -2420 c2 -273 0 -312 -17 -380 -27
    -107 -66 -175 -146 -255 -80 -80 -161 -127 -261 -151 -64 -16 -361 -17 -4169
    -18 -2255 -1 -4130 2 -4166 6 -66 6 -192 52 -240 86 -64 46 -156 151 -187 216
    -53 108 -61 174 -62 502 0 159 1 292 4 295 2 2 2083 4 4623 4 l4618 0 3 -305z
    m-3873 -1180 c3 -6 10 -31 15 -58 29 -154 68 -312 79 -327 5 -5 11 -24 14 -42
    8 -39 71 -181 109 -244 15 -25 28 -50 28 -55 0 -5 -419 -8 -996 -6 l-996 2 22
    35 c20 32 44 81 100 200 10 22 26 67 36 100 9 33 21 71 26 85 15 37 39 157 44
    220 3 30 7 65 10 78 l4 22 750 0 c490 0 751 -3 755 -10z"/>
    </g>
  </svg>

  <!-- MP1 Data Analyzer -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="!h-6 !w-6" v-if="name === 'mp1-data-analyzer'">
    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
    <path d="M18 17V9"></path>
    <path d="M13 17V5"></path>
    <path d="M8 17v-3"></path>
  </svg>

  <!-- Integration Lab -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="!h-6 !w-6" v-if="name === 'integration-lab'">
    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
    <path d="M18 17V9"></path>
    <path d="M13 17V5"></path>
    <path d="M8 17v-3"></path>
  </svg>

  <!-- Cables Lookup -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    :class="!isTopBar ? 'w-6 h-6' : 'w-5 h-5'"
    v-if="name.includes('cables-lookup')"
  >
    <g>
      <path d="M20.25,2l0,6c-0,0.414 -0.336,0.75 -0.75,0.75l-6,-0c-1.519,-0 -2.75,-1.231 -2.75,-2.75l0,-2c0,-1.519 1.231,-2.75 2.75,-2.75l6,-0c0.414,-0 0.75,0.336 0.75,0.75Zm-1.5,0.75l-5.25,0c-0.69,0 -1.25,0.56 -1.25,1.25l0,2c0,0.69 0.56,1.25 1.25,1.25l5.25,-0l0,-4.5Z"/>
      <path d="M4.5,15.25l6,-0c1.519,0 2.75,1.231 2.75,2.75l-0,2c-0,1.519 -1.231,2.75 -2.75,2.75l-6,-0c-0.414,0 -0.75,-0.336 -0.75,-0.75l0,-6c0,-0.414 0.336,-0.75 0.75,-0.75Zm0.75,1.5c-0,0 0,4.5 0,4.5l5.25,-0c0.69,-0 1.25,-0.56 1.25,-1.25l-0,-2c-0,-0.69 -0.56,-1.25 -1.25,-1.25l-5.25,0Z"/>
      <path d="M22.75,3.5l-0,3c0,0.414 -0.336,0.75 -0.75,0.75l-2.5,-0c-0.414,-0 -0.75,-0.336 -0.75,-0.75l-0,-3c-0,-0.414 0.336,-0.75 0.75,-0.75l2.5,-0c0.414,-0 0.75,0.336 0.75,0.75Zm-1.5,0.75l-1,-0c0,-0 -0,1.5 0,1.5l1,0l0,-1.5Z"/>
      <path d="M2,16.75l2.5,-0c0.414,0 0.75,0.336 0.75,0.75l0,3c0,0.414 -0.336,0.75 -0.75,0.75l-2.5,-0c-0.414,0 -0.75,-0.336 -0.75,-0.75l0,-3c0,-0.414 0.336,-0.75 0.75,-0.75Zm0.75,1.5c-0,-0 0,1.5 0,1.5l1,0c0,0 0,-1.5 -0,-1.5l-1,-0Z"/>
      <path d="M22.75,15.502c-0,1.127 -0.448,2.207 -1.244,3.004c-0.797,0.796 -1.877,1.244 -3.004,1.244l-6.002,-0c-0.414,-0 -0.75,-0.336 -0.75,-0.75c-0,-0.414 0.336,-0.75 0.75,-0.75l6.002,-0c0.729,0 1.428,-0.29 1.943,-0.805c0.512,-0.511 0.801,-1.204 0.805,-1.934c0,-0.004 0,-0.009 0,-0.013c-0,-1.518 -1.23,-2.748 -2.748,-2.748l-12.752,-0c-1.193,0 -2.338,-0.474 -3.182,-1.318c-0.844,-0.844 -1.318,-1.989 -1.318,-3.182c0,-1.193 0.474,-2.338 1.318,-3.182c0.844,-0.844 1.989,-1.318 3.182,-1.318l5.75,0c0.414,0 0.75,0.336 0.75,0.75c-0,0.414 -0.336,0.75 -0.75,0.75l-5.75,0c-0.796,-0 -1.559,0.316 -2.121,0.879c-0.563,0.562 -0.879,1.325 -0.879,2.121c-0,0.796 0.316,1.559 0.879,2.121c0.562,0.563 1.325,0.879 2.121,0.879l12.752,0c2.346,0 4.248,1.902 4.248,4.248c0,0.001 0,0.003 -0,0.004Z"/>
    </g>
  </svg>
</template>

<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  isTopBar: {
    type: Boolean,
    default: false,
  },
});
</script>
